module.exports = __webpack_public_path__ + "media/images/vp/icon.rightarrow.white-01d105172f0376503f24e67d7841a6aa.svg";